import type { AppRouter } from '@projetive-op/api'
import { createTRPCClient, httpBatchLink, httpSubscriptionLink, splitLink } from '@trpc/client'
import { createTRPCContext } from '@trpc/tanstack-react-query'
import superjson from 'superjson'

import { HEADER_DISPOSITIVO, obterTokenDispositivo } from './dispositivo'

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>()

const url = `${import.meta.env.VITE_API_URL ?? ''}/trpc`

export function criarTrpcClient() {
  return createTRPCClient<AppRouter>({
    links: [
      splitLink({
        condition: (op) => op.type === 'subscription',
        // Subscriptions (painel em tempo real) viajam por SSE…
        true: httpSubscriptionLink({
          url,
          transformer: superjson,
          eventSourceOptions: { withCredentials: true },
        }),
        // …e o resto em lote por HTTP, sempre com o cookie de sessão e, no
        // tablet vinculado, o token do dispositivo (ADR 0010).
        false: httpBatchLink({
          url,
          transformer: superjson,
          headers: () => {
            const token = obterTokenDispositivo()
            return token ? { [HEADER_DISPOSITIVO]: token } : {}
          },
          fetch: (input, init) =>
            fetch(input, { ...(init as RequestInit), credentials: 'include' }),
        }),
      }),
    ],
  })
}

export type TrpcClient = ReturnType<typeof criarTrpcClient>
